(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-service/assets/javascripts/use-race-summaries.js') >= 0) return;  svs.modules.push('/components/racing/race-service/assets/javascripts/use-race-summaries.js');

'use strict';

const parseISO = dateFns.parseISO;
const compareAsc = dateFns.compareAsc;
const useState = React.useState;
const useEffect = React.useEffect;
const useRaceSummaries = (racecard, mode) => {
  const [summaries, setSummaries] = useState([]);
  useEffect(() => {
    if (!racecard) {
      return undefined;
    }
    if (mode) {
      setSummaries(sortRaceSummariesHot(racecard));
    } else {
      const allRaceSummaries = racecard.reduce((acc, meeting) => acc.concat(meeting.raceSummaries), []);
      allRaceSummaries.sort((a, b) => compareAsc(parseISO(a.startTime), parseISO(b.startTime)));
      setSummaries(allRaceSummaries);
    }
  }, [racecard, mode]);
  return summaries;
};

const sortRaceSummariesHot = summaries => summaries.slice(0, 5);
svs.racing.raceService.useRaceSummaries = useRaceSummaries;

 })(window);